/**
 * Recent Viewed Products Logic
 * Fixes: Swiper initialization and data-handling bugs
 */

const recentViewdProduct = document.querySelector(".recently_viewed_proudct");
const recentViewedProductHandle = recentViewdProduct ? recentViewdProduct.dataset.productHandle : null;
var LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY = "shopify-recent-view";
var LOCAL_STORAGE_DELIMITER = ",";

var selectors = {
  grid: "[grid-recentViewProduct]",
};

document.addEventListener("DOMContentLoaded", function () {
  if (!recentViewdProduct) return;

  var productHandle = recentViewedProductHandle || false;
  
  // Voeg huidig product toe aan de lijst
  if (productHandle) {
    updaterecentViewPorduct(productHandle);
  }

  // Bouw de grid op
  var Recentgrid = document.querySelector(selectors.grid) || false;
  if (Recentgrid) {
    recentViewsetupGrid(Recentgrid);
  }
});

/**
 * Haalt de producten op en vult de slider/grid
 */
var recentViewsetupGrid = function (Recentgrid) {
  var recentViewPorduct = getrecentViewPorduct();
  
  // Toon de sectie alleen als er meer dan alleen het huidige product is
  if (recentViewPorduct.length > 1) {
    recentViewdProduct.classList.remove("no-js-inline");
  } else {
    return; // Stop als er niks te tonen valt
  }

  // Maak requests voor elk product in de lijst (behalve het huidige)
  var requestsRecentViewed = recentViewPorduct
    .slice(0)
    .reverse()
    .map(function (handle) {
      if (recentViewedProductHandle !== handle) {
        var productTileTemplateUrl = "/products/" + handle + "?view=card";
        return fetch(productTileTemplateUrl).then(function (res) {
          return res.status === 200 ? res.text() : null;
        });
      }
      return null;
    });

  Promise.all(requestsRecentViewed).then(function (responses) {
    var recentViewPorductProductCards = responses
      .filter(function(r) { return r !== null && r !== ""; })
      .join("");
    
    // Injecteer de HTML in de grid
    Recentgrid.innerHTML = recentViewPorductProductCards;

    // FIX: Wacht kort tot de browser de HTML heeft gerenderd, update dan de Swiper
    setTimeout(function() {
      var swiperEl = recentViewdProduct.querySelector('.swiper');
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.update();
        swiperEl.swiper.updateSlides();
        swiperEl.swiper.updateProgress();
        console.log("Recently viewed slider updated");
      }
    }, 300); // 300ms is meestal genoeg voor een stabiele render
  });
};

/**
 * Utility: Haal lijst op uit LocalStorage
 */
var getrecentViewPorduct = function () {
  var recentViewPorduct = localStorage.getItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY) || false;
  if (recentViewPorduct) return recentViewPorduct.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

/**
 * Utility: Sla lijst op in LocalStorage
 */
var setrecentViewPorduct = function (array) {
  var recentViewPorduct = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) {
    localStorage.setItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY, recentViewPorduct);
  }
  return recentViewPorduct;
};

/**
 * Utility: Voeg nieuw product toe en voorkom duplicaten
 */
var updaterecentViewPorduct = function (handle) {
  var recentViewPorduct = getrecentViewPorduct();
  var indexInrecentViewPorduct = recentViewPorduct.indexOf(handle);

  if (indexInrecentViewPorduct !== -1) {
    // Verwijder als het al bestaat om het achteraan (meest recent) te zetten
    recentViewPorduct.splice(indexInrecentViewPorduct, 1);
  }
  
  recentViewPorduct.push(handle);

  // Optioneel: Limiteer de lijst tot bijv. de laatste 12 producten
  if (recentViewPorduct.length > 12) {
    recentViewPorduct.shift();
  }

  return setrecentViewPorduct(recentViewPorduct);
};

var resetrecentViewPorduct = function () {
  return setrecentViewPorduct([]);
};